<script setup lang="ts">
import {computed, ref} from "vue";

import trackersReportsService from "@/services/trackers-reports.service";
import fileHelper from "@/helpers/file";
import Insights from "@/views/profile/reportsPreviews/Insights.vue";
import DeepDive from "@/views/profile/reportsPreviews/DeepDive.vue";
import Compare from "@/views/profile/reportsPreviews/Compare.vue";

const {report} = defineProps(['report']);

const downloading = ref(false);
const fileName = computed(() => `${report.tracker_name}_${report.report_type_name.replace(/ /g, '')}`);

async function download() {
    downloading.value = true;
    const {data} = await trackersReportsService.downloadReport(report.id);

    let currentDate = new Date();
    fileHelper.download(data, `${fileName.value}-${currentDate.toLocaleDateString()}.pdf`);
    downloading.value = false;
}
</script>

<template>
    <div class="main-startup__tabs__item">
        <header class="main-startup__tabs__header">
            <h4 class="heading4 heading4--tertiary">Tracker Report - {{report.report_type_name}}</h4>

            <template v-if="downloading">
                <span>Downloading...</span>
            </template>

            <a v-else class="button-download" @click="download">
                Download
            </a>
        </header>

        <div class="main-startup__tabs__item__inner">
            <div class="content">
                <div v-if="report.report_type !== 'comparison'" class="preview">
                    <Insights
                        v-if="report.report_type === 'insights'"
                        :report="report"
                    />

                    <DeepDive
                        v-if="report.report_type === 'deep_dive'"
                        :report="report"
                    />

                    <Compare
                        v-if="report.report_type === 'compare'"
                        :report="report"
                    />
                </div>

                <div class="report-footer">
                    <div class="report-footer__pdf">
                        <span class="report-footer__pdf__name">{{fileName}}</span>.pdf
                    </div>

                    <div>
                        Generated by {{report.user}} on {{(new Date(report.created_at)).toLocaleDateString()}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .content {
        display: block !important;
        border: 1px solid #ddd;
        border-radius: 8px;

        .preview {
            max-width: 850px;
            margin: auto;
            height: 260px;
            overflow: hidden;
        }

        .report-footer {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 20px;
            padding: 20px;
            background-color: #f2f2f2;
        }
        @media (min-width: 1025px) {
            .report-footer {
                flex-direction: row;
            }
        }
        .report-footer__pdf {
            .report-footer__pdf__name {
                display: inline-block;
                max-width: 80%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: middle;
            }
        }
    }
</style>
